module.exports = __webpack_public_path__ + "media/5x5.bf183056.png";